import template from './bot-flow.html';
import controller from './bot-flow.controller';
import './bot-flow.styl';

let botFlowComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default botFlowComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-flow/bot-flow.component.js
 **/